module.exports = __webpack_public_path__ + "static/media/map-pin.bde0f321.svg";